import './nediAnatomy.css'

/** Compact status chip (offline / fixture) using Nedi chip geometry. */
export default function NediStatusChip({ children, compact = false, className = '', title }) {
  return (
    <span
      className={`nedi-chip-status${compact ? ' nedi-chip-status--compact' : ''}${className ? ` ${className}` : ''}`}
      role="status"
      title={title}
      data-nedi-anatomy="chip"
    >
      {children}
    </span>
  )
}
